import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import SearchResults from './components/SearchResults';
import HotelDetails from './components/HotelDetails';
import { AppProvider } from './context/AppContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HotelList from './components/HotelList';
import Hotels from './components/Hotels';
import Flights from './components/Flights';
import Destinations from './components/Destinations';
import Packages from './components/Packages';
import About from './components/About';
import PartnerHotels from './components/PartnerHotels';
import StyledSearchBar from './components/StyledSearchBar';
import HotelCard from './components/HotelCard';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Register from './components/Register';
import Account from './components/Account';
import StaySearchBar from './components/StaySearchBar';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

// Import CSS files
import './App.css';
import './components/Home.css';
import './components/Header.css';
import './components/Footer.css';
import './components/StyledSearchBar.css';
import './components/Account.css';
import './components/AIChat.css';
import './components/StaySearchBar.css';
import './components/CurrencySelector.css';
import './components/LanguageSelector.css';
import './components/Hotels.css';
import './components/Flights.css';
import './components/Destinations.css';
import './components/Packages.css';
import './components/About.css';
import './components/PartnerHotels.css';
import './components/Auth.css';
import './components/HotelDetails.css';
import './components/BookingForm.css';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
        <div className="App">
            <Header />
            {isHome && <StaySearchBar />}
            <main className="main-content">{children}</main>
            <Footer />
        </div>
    );
};

const App: React.FC = () => {
    return (
        <AppProvider>
            <Router>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/search" element={<SearchResults />} />
                        <Route path="/hotels" element={<Hotels />} />
                        <Route path="/partner-hotels" element={<PartnerHotels />} />
                        <Route path="/flights" element={<Flights />} />
                        <Route path="/destinations" element={<Destinations />} />
                        <Route path="/packages" element={<Packages />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/hotel" element={<HotelDetails />} />

                        {/* Auth */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />

                        {/* Protected examples */}
                        <Route element={<ProtectedRoute />}> 
                            <Route path="/account" element={<Account />} />
                        </Route>
                    </Routes>
                </Layout>
            </Router>
        </AppProvider>
    );
};

export default App;
